<template>
  <v-app dark>
    <app-loading :overlay="overlay" />
    <app-drawer-left ref="drawer" :menus="menus" @toggle="drawerOpen = $event" />
    <v-app-bar flat height="63" fixed app>
      <v-btn
        icon
        class="ps-drawer-toggle-btn"
        @click.stop="$refs.drawer.toggleSidebar()"
      >
        <v-icon small>{{
          drawerOpen ? "fal fa-arrow-left" : "fal fa-arrow-right"
        }}</v-icon>
      </v-btn>
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mobile"
        @click.stop="$refs.drawerRight.drawer = !$refs.drawerRight.drawer"
      />
      <span
        v-if="pageTitle"
        class="page-header-title ml-3"
        :title="pageTitle"
      >
        {{ pageTitle }}
      </span>
      <v-spacer />
      <v-menu offset-y bottom right>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            fab
            depressed
            small
            v-bind="attrs"
            v-on="on"
            class="font-weight-medium"
          >
            <v-icon small> fal fa-globe </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(locale, index) in locales"
            :key="index"
            @click="changeLocale(locale.code)"
          >
            <v-list-item-avatar size="20">
              <v-img :src="locale.flag" />
            </v-list-item-avatar>

            <v-list-item-title>{{ locale.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn class="ml-3" fab depressed small @click="changeTheme">
        <v-icon small>fal fa-{{ darkMode === true ? "sun" : "moon" }}</v-icon>
      </v-btn>
      <v-btn class="ml-3" fab depressed small @click="logoutMethod">
        <v-icon small>fal fa-sign-out-alt</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main class="overflow-y-auto ps-page-padded">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AppDrawerLeft from "@/components/layouts/drawerLeftOnline";
import { mapGetters, mapActions } from "vuex";
import { myMixin } from "@/mixin/main";
import { setUser, checkToken } from "@/controllers/auth";
import { confirm } from "@/controllers/alert";

export default {
  components: { AppDrawerLeft },
  mixins: [myMixin],
  data() {
    return {
      drawerOpen: true,
      darkMode: false,
      menus: [
        {
          name: "dashboard",
          icon: "fal fa-tachometer-alt",
          to: "/dashboard/index",
        },
        {
          name: "orders",
          icon: "fal fa-shopping-cart",
          to: "/dashboard/orders",
        },

        {
          name: "products",
          icon: "fal fa-boxes",
          to: "/dashboard/products",
        },
        {
          name: "categories",
          icon: "fal fa-list",
          to: "/dashboard/categories",
        },
        {
          name: "banners",
          icon: "fal fa-images",
          to: "/dashboard/banners",
        },
        {
          name: "payments",
          icon: "fal fa-credit-card",
          to: "/dashboard/payments",
        },
        {
          name: "followers",
          icon: "fal fa-users",
          to: "/dashboard/users",
        },
        {
          name: "settings",
          icon: "fal fa-cogs",
          to: "/dashboard/settings",
        },
      ],
    };
  },

  created() {
    checkToken(this);
    const thems = localStorage.getItem("darkMode");
    if (thems) {
      if (thems.length === 4) {
        this.$vuetify.theme.dark = true;
        this.darkMode = true;
      } else {
        this.$vuetify.theme.dark = false;
        this.darkMode = false;
      }
    }
  },
  mounted() {
    setUser(this);
    this.checkStore();
  },

  watch: {
    darkMode(value) {
      this.$vuetify.theme.dark = value;
      localStorage.setItem("darkMode", value);
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      overlay: "index/overlay",
      locales: "auth/locales",
    }),
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    }),
    async checkStore() {
      try {
        const { data } = await this.$http.post("check_join");
      } catch (error) {
        setTimeout(() => {
          if (window.opener) {
            window.close();
          }
        }, 3000);
        console.log(error);
      }
    },
    changeTheme() {
      this.darkMode = !this.darkMode;
      const value = !this.$vuetify.theme.dark;
      this.$vuetify.theme.dark = value;
      localStorage.setItem("darkMode", value);
    },
    changeLocale(code) {
      localStorage.setItem("locale", code);
      this.$i18n.locale = code;
    },
    async logoutMethod() {
      try {
        const { isConfirmed } = await confirm({
          props: this,
          text: "want_to_logout",
        });
        if (isConfirmed) {
          await this.logout(this);
          window.location.href = "/";
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.page-header-title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme--light .page-header-title {
  color: #141021;
}

.ps-drawer-toggle-btn {
  width: 32px !important;
  height: 32px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff;
  border-radius: 8px !important;
  color: #94a3b8;
  transition: color 0.15s ease, border-color 0.15s ease,
    background-color 0.15s ease;
}

.ps-drawer-toggle-btn:hover {
  color: #5b39c9 !important;
  border-color: #5b39c9 !important;
  background: #f3f0fc !important;
}

.theme--dark .ps-drawer-toggle-btn {
  background: transparent;
  border-color: #2f333a !important;
  color: rgba(226, 232, 240, 0.6);
}

.theme--dark .ps-drawer-toggle-btn:hover {
  color: #7c5cea !important;
  border-color: #7c5cea !important;
  background: rgba(91, 57, 201, 0.2) !important;
}
</style>
